/* eslint-disable react/prop-types */
import { TableCell, TableRow } from "@mui/material";
import React from "react";
import moment from "moment";
import Table from "../../../../components/common/new/Table/Table";
// import tableStyle from "../../../../theme/styles/table";
import styles from "./GohonzonReportsTable.styles";
import Typography from "../../../../components/common/new/Typography/Typography";
// import NewTable from "../../../member/components/Newtable/NewTable";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};

const GOHONZON_SEAECH_TABLE_COL = [
  {
    displayName: "S.No",
    key: "s.no",
  },
  {
    displayName: "Member ID",
    key: "id",
  },
  {
    displayName: "Member Name",
    key: "fullName",
  },
  {
    displayName: "Address",
    key: "address",
  },
  {
    displayName: "Contact Info",
    key: "contactInfo",
  },
  {
    displayName: "Organization Structure",
    key: "orgstructure",
  },
  {
    displayName: "Application Date",
    key: "applicationDate",
  },
  {
    displayName: "Allotment Date",
    key: "allotmentDate",
  },
  {
    displayName: "Conferral Date",
    key: "conferralDate",
  },
];

const getRows = ({ searchData, currentPage, pageSize }) =>
  searchData.map((gohonzon, index) => {
    const serialNumber = index + 1 + currentPage * pageSize;
    return (
      <TableRow>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {serialNumber}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {gohonzon?.memberId || "NA"}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {gohonzon?.fullName || "NA"}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {gohonzon?.address?.addressLine || "NA"}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {gohonzon?.mobileNumber || "NA"}
            </Typography>
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {[
                gohonzon?.orgStructure?.areaName,
                gohonzon?.orgStructure?.zoneName,
                gohonzon?.orgStructure?.regionName,
                gohonzon?.orgStructure?.chapterName,
                gohonzon?.orgStructure?.districtName,
                gohonzon?.orgStructure?.blockName,
              ]
                .filter(Boolean)
                .join("/ ")}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {gohonzon?.applicationDate
                ? moment(gohonzon?.applicationDate).format("DD/MM/YYYY")
                : "-"}{" "}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {gohonzon?.allotmentDate
                ? moment(gohonzon?.allotmentDate).format("DD/MM/YYYY")
                : "-"}{" "}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {gohonzon?.conferredDate
                ? moment(gohonzon?.conferredDate).format("DD/MM/YYYY")
                : "-"}{" "}
            </Typography>{" "}
          </div>
        </TableCell>
      </TableRow>
    );
  });

function ReportTable({ searchData, currentPage, pageSize }) {
  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={GOHONZON_SEAECH_TABLE_COL}
        rows={getRows({
          searchData,
          currentPage,
          pageSize,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          textAlign: "center",
        }}
      />
    </div>
  );
}

export default ReportTable;
